module.exports = __webpack_public_path__ + "static/media/us-flag.979cddc0.png";